export const rules = {
	// Card titles
	"rules.card.rules.title": "Правила",
	"rules.card.goals.title": "Голове",
	"rules.card.cleanSheets.title": "Сухи мрежи",
	"rules.card.cards.title": "Картони",
	"rules.card.misc.title": "Разни",
	"rules.card.captains.title": "Капитани и Вицекапитани",
	"rules.card.eligibility.title": "Право на участие и Награди",
	"rules.card.weeklyPrizes.title": "Структура на седмичните награди",
	"rules.card.finalRules.title": "Разпределение на наградите и При равен резултат",

	// Main rules content
	"rules.intro":
		'Всички термини с главни букви, използвани в тези правила (<strong>"Правила"</strong>), имат значението, определено в общите условия (<strong>"Общи условия"</strong>).',

	"rules.rule1":
		"Участниците могат да избират своя най-добър отбор всяка седмица/кръг (според случая), съответно на състезанието, към което се отнася играта Betway Scores BW Fantasy Football, напр. Висшата лига на Англия и др. Състезанието Betway Scores BW Fantasy Football започва на 11 март 2025 г. и ще приключи в края на футболния сезон 2025/2026.",

	"rules.rule2": "Всяка седмица/кръг съответства на кръговете в тази лига.",

	"rules.rule3":
		"Участниците могат да избират максимум двама (2) играчи от всеки участващ отбор в лигата, които да включат в своя отбор Betway Scores BW Fantasy Football всяка седмица/кръг.",

	"rules.rule4":
		"Участниците трябва активно да избират своя отбор всяка седмица/кръг, с възможност да правят промени или да запазят същия отбор за следващата седмица/кръг.",

	"rules.rule5":
		"Точките се присъждат както следва за всяко от следните действия, извършени от играчите, които участникът е избрал в своя отбор Betway Scores BW Fantasy Football всяка седмица/кръг:",

	// Goals points
	"rules.goals.forwardGoals": "Голове на нападател",
	"rules.goals.forwardGoalsValue": "4",
	"rules.goals.midfielderGoals": "Голове на полузащитник",
	"rules.goals.midfielderGoalsValue": "5",
	"rules.goals.defenderGoals": "Голове на защитник",
	"rules.goals.defenderGoalsValue": "10",
	"rules.goals.goalkeeperGoals": "Голове на вратар",
	"rules.goals.goalkeeperGoalsValue": "20",
	"rules.goals.penaltyGoals": "Голове от дузпа",
	"rules.goals.penaltyGoalsValue": "3",
	"rules.goals.ownGoals": "Автоголове",
	"rules.goals.ownGoalsValue": "-5",
	"rules.goals.concededGoals": "Допуснати голове",
	"rules.goals.concededGoalsValue": "-1",

	// Clean sheets points
	"rules.cleanSheets.goalkeeperCleanSheet": "Суха мрежа на вратар",
	"rules.cleanSheets.goalkeeperCleanSheetValue": "5",
	"rules.cleanSheets.defenderCleanSheet": "Суха мрежа на защитник",
	"rules.cleanSheets.defenderCleanSheetValue": "5",
	"rules.cleanSheets.midfielderCleanSheet": "Суха мрежа на полузащитник",
	"rules.cleanSheets.midfielderCleanSheetValue": "1",

	// Cards points
	"rules.cards.yellowCard": "Жълти картони",
	"rules.cards.yellowCardValue": "-2",
	"rules.cards.redCard": "Червени картони",
	"rules.cards.redCardValue": "-5",

	// Misc points
	"rules.misc.assists": "Асистенции",
	"rules.misc.assistsValue": "4",
	"rules.misc.shotsOnTarget": "Удари в целта",
	"rules.misc.shotsOnTargetValue": "1",
	"rules.misc.tackles": "Отнемания",
	"rules.misc.tacklesValue": "2",
	"rules.misc.saves": "Спасени удари",
	"rules.misc.savesValue": "1",
	"rules.misc.minutesOver60": "Игрови минути равни или над 60",
	"rules.misc.minutesOver60Value": "2",
	"rules.misc.minutesUnder60": "Игрови минути под 60",
	"rules.misc.minutesUnder60Value": "1",
	"rules.misc.penaltyWon": "Спечелена дузпа",
	"rules.misc.penaltyWonValue": "3",
	"rules.misc.penaltiesConceded": "Допусната дузпа",
	"rules.misc.penaltiesConcededValue": "-3",
	"rules.misc.penaltyMissed": "Пропусната дузпа",
	"rules.misc.penaltyMissedValue": "-3",
	"rules.misc.offsides": "Засади",
	"rules.misc.offsidesValue": "-1",
	"rules.misc.foulsCommitted": "Извършени нарушения",
	"rules.misc.foulsCommittedValue": "-1",

	// Captain rules
	"rules.rule6":
		'Участниците могат да определят <strong>"Капитан"</strong> на своя отбор, който ще получава 3х точки. Капитанът може да бъде сменян всяка седмица/кръг. Дали капитанът ще бъде сменен или ще остане същият за следващата седмица/кръг, трябва да бъде активно избрано от участника.',

	"rules.rule7":
		'Участниците могат да определят <strong>"Вицекапитан"</strong> на своя отбор, който ще получава 2х точки. Вицекапитанът може да бъде сменян всяка седмица/кръг. Дали ще бъде сменен или ще остане същият за следващата седмица/кръг, трябва да бъде активно избрано от участника.',

	// Eligibility and prizes
	"rules.rule8":
		"Всички влезли потребители на Betway Scores и/или BW Scores имат право да играят BW Fantasy Football, но само участници с верифициран Betway акаунт към момента на присъждане на наградите имат право да спечелят награди. Промени в резултатите по т. 2 (влияещи на точките по т. 5), настъпили след присъждане на наградите (напр. анулиране на резултати), няма да бъдат отчитани със задна дата.",

	"rules.rule9":
		"Квалифицираният участник, който завърши сезона на първо място и има Betway акаунт, ще бъде носител на Голямата награда за сезона и ще спечели пътуване за двама (2) за да гледат Арсенал в Лондон, включително полети (ако е необходимо), настаняване (ако е необходимо) и £500 джобни пари.",

	"rules.rule10":
		"Ако носителят на Голямата награда не може да пътува поради липса на валиден паспорт и/или виза и/или други ограничения, ще получи награда от €5 000 в брой или приблизителен еквивалент в местна валута към датата на началото на състезанието (съответно £4 500, R100 000 или GH₵ 60 000), по своя Betway акаунт след края на състезанието.",

	"rules.rule11":
		"Носителят на Голямата награда може да избере да не приема пътуването и вместо това да получи €5 000 в брой или приблизителен еквивалент в местна валута към датата на началото на състезанието (съответно £4 500, R100 000 или GH₵ 60 000), по своя Betway акаунт.",

	"rules.rule12":
		"Седмичните награди ще бъдат присъждани на първите 10 участници всяка седмица/кръг, които имат валиден Betway акаунт. Ако някой от топ 10 няма Betway акаунт, няма да получи награда.",

	"rules.rule13": "Седмичните места от 1 до 10 ще получават следните парични награди (в зависимост от региона) по своя Betway акаунт:",

	// Weekly prize table headers
	"rules.weeklyPrizes.position": "Позиция за кръга",
	"rules.weeklyPrizes.eur": "Парична награда (EUR)",
	"rules.weeklyPrizes.gbp": "Парична награда (GBP)",
	"rules.weeklyPrizes.zar": "Парична награда (ZAR)",
	"rules.weeklyPrizes.ghs": "Парична награда (GHS)",

	// Weekly prize values
	"rules.weeklyPrizes.1st.eur": "€150",
	"rules.weeklyPrizes.1st.gbp": "£150",
	"rules.weeklyPrizes.1st.zar": "R3000",
	"rules.weeklyPrizes.1st.ghs": "GH₵ 2000",

	"rules.weeklyPrizes.2nd.eur": "€100",
	"rules.weeklyPrizes.2nd.gbp": "£100",
	"rules.weeklyPrizes.2nd.zar": "R2000",
	"rules.weeklyPrizes.2nd.ghs": "GH₵ 1250",

	"rules.weeklyPrizes.3rd.eur": "€75",
	"rules.weeklyPrizes.3rd.gbp": "£75",
	"rules.weeklyPrizes.3rd.zar": "R1500",
	"rules.weeklyPrizes.3rd.ghs": "GH₵ 1000",

	"rules.weeklyPrizes.4th.eur": "€50",
	"rules.weeklyPrizes.4th.gbp": "£50",
	"rules.weeklyPrizes.4th.zar": "R1000",
	"rules.weeklyPrizes.4th.ghs": "GH₵ 600",

	"rules.weeklyPrizes.5th.eur": "€40",
	"rules.weeklyPrizes.5th.gbp": "£40",
	"rules.weeklyPrizes.5th.zar": "R800",
	"rules.weeklyPrizes.5th.ghs": "GH₵ 500",

	"rules.weeklyPrizes.6th.eur": "€30",
	"rules.weeklyPrizes.6th.gbp": "£30",
	"rules.weeklyPrizes.6th.zar": "R600",
	"rules.weeklyPrizes.6th.ghs": "GH₵ 400",

	"rules.weeklyPrizes.7th.eur": "€20",
	"rules.weeklyPrizes.7th.gbp": "£20",
	"rules.weeklyPrizes.7th.zar": "R400",
	"rules.weeklyPrizes.7th.ghs": "GH₵ 250",

	"rules.weeklyPrizes.8th.eur": "€15",
	"rules.weeklyPrizes.8th.gbp": "£15",
	"rules.weeklyPrizes.8th.zar": "R300",
	"rules.weeklyPrizes.8th.ghs": "GH₵ 200",

	"rules.weeklyPrizes.9th.eur": "€10",
	"rules.weeklyPrizes.9th.gbp": "£10",
	"rules.weeklyPrizes.9th.zar": "R200",
	"rules.weeklyPrizes.9th.ghs": "GH₵ 100",

	"rules.weeklyPrizes.10th.eur": "€10",
	"rules.weeklyPrizes.10th.gbp": "£10",
	"rules.weeklyPrizes.10th.zar": "R200",
	"rules.weeklyPrizes.10th.ghs": "GH₵ 100",

	// Final rules
	"rules.rule14":
		"Седмичните награди ще бъдат присъждани в рамките на 7 (седем) дни след финализиране на резултатите за съответната седмица, а Голямата награда — в рамките на 7 (седем) дни след приключване на състезанието Betway Scores BW Fantasy Football.",

	"rules.rule15":
		"В случай на равенство за седмичните награди, паричната награда за тази позиция (и съответните позиции под нея, засегнати от равенството) ще бъде разделена по равно между участниците с равен резултат.",

	"rules.rule16":
		"В случай на равенство за Голямата награда ще бъде използван случаен механизъм за избор само на един от участниците с равен резултат за победител.",

	"rules.temporary_notice":
		"Моля, имайте предвид, че победителите на награди за периода от 19 декември 2025 г. до 2 януари 2026 г. ще получат наградите си в рамките на 7 (седем) дни, считано от 6 януари 2026 г.",
};
